export const STORE_REFERENCE_DATA = 'ReferenceDataUI';
export type STORE_REFERENCE_DATA = typeof STORE_REFERENCE_DATA;

export const STORE_REFERENCE_DATA_USAGE = 'ReferenceDataUsageUI';
export type STORE_REFERENCE_DATA_USAGE = typeof STORE_REFERENCE_DATA_USAGE;
